import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const ShortcutsInfo = styled.div`
  font-size: 14px;
  color: ${withVar(DesignToken.ContentBasicSecondary)};
  line-height: 1.3;
  margin-top: 5px;
`;

export const StyledShortcutsLabel = styled.span`
  color: ${withVar(DesignToken.ContentBasicSecondary)};
  font-size: 16px;
  font-variant: small-caps;
  font-weight: 600;
  margin-right: 5px;
`;

export const ShortcutWrapper = styled.span`
  display: inline-block;
  margin: 2px 3px;
  word-break: break-word;
`;

export const UpdateInformationText = styled.div`
  @media (min-width: 900px) {
    max-width: 18ch;
  }
`;
